const routes = [
    {
        path: '/',
        template: '/assets/templates/homepage/index.html'
    },
    {
        path: '/404',
        template: '/assets/templates/development/404.html'
    },
    {
        path: '/styleguide',
        template: '/assets/templates/development/styleguide.html'
    }
];

export default routes;
